/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Tue Jun 14 2022
*  File : SessionStorageInterface.ts
*******************************************/

import { hasOptionalPropertyOfType } from "@ciaopeople/cp-shatsu/CustomTypes";
import { isFunction, isNumber, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { SessionProvider } from "./SessionProvider.js";
import { StorableSession } from "./StorableSession.js";
export const COOKIE_CHG_EVENT = "cookiechange";
export interface SessionStorageInterface extends SessionProvider {
    startCookieMonitoring(cookieName: string): Promise<void>,
    stopCookieMonitoring(cookieName: string): Promise<void>,
    thereWasASession(): Promise<boolean>,
    isAutologinLocked(): Promise<boolean>,
    blockAutologin(): Promise<void>,
    blockAutologinLonger(): Promise<void>,
    unlockAutologin(): Promise<void>,
    getLoginPreviousState(): Promise<string>,
    setLoginPreviousState(loggedIn: boolean): Promise<void>,
    setLastLoginProvider(provider: string): Promise<void>,
    getLastLoginProvider(): Promise<string>,
    getFacebookLoginToken(): Promise<string>,
    setFacebookLoginToken(tk: string): Promise<void>,
    cancelFacebookLogin(): Promise<void>,
    clearFacebookLoginToken(): Promise<void>,
    isFacebookTokenClean(): Promise<boolean>
    cookieVersionStore(): Promise<void>,
    shouldUpdateCookies(): Promise<boolean>,
    storeSession(session: StorableSession): Promise<void>,
    clearSession(): Promise<void>,
    onCookieChange(f: (cookieChangeEvent: CookieChangeEventData) => void): void

    storeSessionAndProvider(session: StorableSession, provider: string): Promise<void>;
    
}


export type SessionStorageMethod = keyof SessionStorageInterface;

export const AllSessionStorageMethods: SessionStorageMethod[] = [
    "startCookieMonitoring",
    "stopCookieMonitoring",
    "thereWasASession",
    "isAutologinLocked",
    "blockAutologin",
    "blockAutologinLonger",
    "unlockAutologin",
    "getLoginPreviousState",
    "setLoginPreviousState",
    "setLastLoginProvider",
    "getLastLoginProvider",
    "cancelFacebookLogin",
    "clearFacebookLoginToken",
    "isFacebookTokenClean",
    "cookieVersionStore",
    "shouldUpdateCookies",
    "storeSession",
    "clearSession",
    "getSession",
    "onCookieChange",
    "getFacebookLoginToken",
    "setFacebookLoginToken",
    "storeSessionAndProvider"
];


export function isSessionStorageInterface(obj: any): obj is SessionStorageInterface {
    return isObject(obj) && AllSessionStorageMethods.
        reduce((carry, cur) => carry && isFunction(obj[cur]), true );
}

export interface SessionHelperOptions {
    /**
     * Frequenza di monitoraggio in millisecondi
     */
    monitorFrequency?: number;

}

export function isSessionHelperOptions(obj: any): obj is SessionHelperOptions {
    return isObject(obj) && isString(obj.cookieDomain) && hasOptionalPropertyOfType(obj, "monitorFrequency", isNumber);
}

export interface CookieChangeEventData {
    /**
     * *nomedelcookie*
     */
    name: string;
    /**
     * *valoreCorrenteDelCookie*
     */
    val: string;
    /**
     * *vecchioValoreDelCookie*
     */
    oldval: string;
}

export function isCookieChangeEventData(obj: any): obj is CookieChangeEventData {
    return isObject(obj) && 
            isString(obj.name);
}